import * as React from 'react';

import { LocalizedText } from '@shared-ui/localization-context';

import { UitkButtonSize, UitkPrimaryButton } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkLoader } from 'uitk-react-loader';

interface ISubmitProps {
  isLoading?: boolean;
}

function Submit({ isLoading }: ISubmitProps): JSX.Element {
  return (
    <section className="submit">
      <UitkSpacing padding={{ inline: 'twelve' }}>
        <UitkPrimaryButton className="submit__button" type="submit" size={UitkButtonSize.LARGE}>
          {isLoading ? (
            <UitkLoader isSmall={true} isDarkBackground={true} />
          ) : (
            <LocalizedText message="product.search.form.button.label" />
          )}
        </UitkPrimaryButton>
      </UitkSpacing>
    </section>
  );
}

export { Submit };
